export const StatementExportFileType = {
  Pdf: 'Pdf',
  Excel: 'Excel',
} as const;
export type StatementExportFileType = (typeof StatementExportFileType)[keyof typeof StatementExportFileType];
